export default "__VITE_ASSET__BA4_fm1B__"